module.exports = __webpack_public_path__ + "img/dictionaries_icon.7bb0889f.svg";